/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import copy from 'copy-to-clipboard'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import ModalContainer from '../ModalContainer'
import Button from '../../Button'
import { hideModal, showErrorNotification } from '../../../redux/actions'
import { useCreateTestRedemptionSessionMutation } from '../../../redux/slices/offersSlice'

export function CreateTestRedemptionSessionModal({ offer }) {
  const dispatch = useDispatch()
  const [createTestRedemptionSession, { isLoading }] = useCreateTestRedemptionSessionMutation()

  const [subjectToken, setSubjectToken] = useState(null)
  const [copied, setCopied] = useState(false)

  const onClose = () => dispatch(hideModal())
  const createSession = async () => {
    try {
      const response = await createTestRedemptionSession(offer.offerId).unwrap()
      setSubjectToken(response.subjectToken)
    } catch {
      dispatch(showErrorNotification('There was an error creating the test redemption session. Please try again.'))
    }
  }
  const copyToken = () => {
    const succeeded = copy(subjectToken)
    if (succeeded) {
      setCopied(true)
    } else {
      dispatch(showErrorNotification('Unable to copy the subject token to clipboard. Please copy it manually.'))
    }
  }

  return (
    <ModalContainer
      title="Create Test Redemption Session"
      modal
      maxWidth="sm"
      fullWidth="false"
      actions={{
        secondaryAction: {
          label: 'Close',
          onClick: onClose,
        },
      }}
    >
      <div style={{ marginTop: '10px' }}>
        {subjectToken ? (
          <div>
            <Typography style={{ color: '#222' }}>
              Test redemption session created. Exchange this subject token at auth.govx.com to
              receive a test access token. It is shown only once — copy it now, as it cannot be
              retrieved later.
            </Typography>
            <div style={{ cursor: 'pointer', justifyContent: 'center' }} onClick={() => copyToken()}>
              <Typography style={{
                marginTop: '25px', padding: '8px', border: 'solid #e3e3e3 1px', borderRadius: '3px', background: '#f7f7f7', color: '#2a2d36', fontFamily: 'monospace', alignItems: 'center', whiteSpace: 'nowrap', overflowX: 'scroll',
              }}
              >
                {subjectToken}
              </Typography>
            </div>
            {copied && (
            <Typography style={{ margin: '0px' }}>
              <small>Subject token copied to clipboard</small>
            </Typography>
            )}
          </div>
        ) : (
          <div>
            <Typography style={{ color: '#222', marginBottom: '20px' }}>
              Create a safe test redemption session for this offer? No real claim or redemption is
              created. A one-time subject token is generated and shown only once.
            </Typography>
            <Button
              label={isLoading ? 'Creating…' : 'Create'}
              icon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
              fullWidth={false}
              disabled={isLoading}
              style={{ backgroundColor: '#f44336', color: 'white' }}
              onClick={() => createSession()}
            >
              Create
            </Button>
          </div>
        )}
      </div>
    </ModalContainer>
  )
}

CreateTestRedemptionSessionModal.propTypes = {
  offer: PropTypes.shape({
    offerId: PropTypes.string.isRequired,
  }).isRequired,
}

export default CreateTestRedemptionSessionModal
